var _path, _circle, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0789 4.60201C15.1712 3.71042 14.0748 3.03407 12.8708 2.62289C11.6667 2.21171 10.3856 2.07621 9.12219 2.22638C7.85874 2.37655 6.64515 2.80856 5.571 3.49052C4.49686 4.17248 3.58959 5.08698 2.91617 6.1665C2.24275 7.24602 1.82038 8.463 1.68024 9.7276C1.5401 10.9922 1.68576 12.2721 2.10647 13.4729C2.52719 14.6737 3.21221 15.7646 4.11098 16.6652C5.00974 17.5658 6.0993 18.2531 7.29921 18.6762C7.60347 18.7788 7.92219 18.8319 8.24326 18.8336C8.99439 18.8336 9.71476 18.5352 10.2459 18.0041C10.777 17.4729 11.0754 16.7526 11.0754 16.0014V15.6946C11.0754 15.4442 11.1749 15.2041 11.3519 15.0271C11.529 14.85 11.7691 14.7506 12.0195 14.7506H15.6541C16.2966 14.7534 16.9207 14.5365 17.423 14.1359C17.9252 13.7352 18.2754 13.1748 18.4154 12.5478C18.5649 11.9058 18.6363 11.248 18.6278 10.5889C18.6202 9.47195 18.3909 8.36765 17.9534 7.33997C17.5158 6.31229 16.8787 5.38166 16.0789 4.60201Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9581,
    cy: 9.74304,
    r: 0.378786,
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.36048,
    cy: 5.9823,
    rx: 0.378786,
    ry: 0.378786,
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3646,
    cy: 5.60242,
    rx: 0.378786,
    ry: 0.378786,
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.22669,
    cy: 10.122,
    rx: 0.378786,
    ry: 0.378786,
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.79163,
    cy: 14.6913,
    rx: 0.378786,
    ry: 0.378786,
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/Palette.d7a4d23421dd982e40da403c771693a4.svg";
export { ForwardRef as ReactComponent };